// src/pages/Community/Missions/MissionDetailPanel.jsx
import React, { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../../firebase";
import MissionDetailContent from "./MissionDetailContent";

export default function MissionDetailPanel({ missionId, user }) {
    const [m, setM] = useState(null);

    useEffect(() => {
        if (!missionId) return;
        return onSnapshot(doc(db, "missions", missionId), (snap) => {
            setM(snap.exists() ? { id: snap.id, ...snap.data() } : null);
        });
    }, [missionId]);

    if (!missionId) {
        return <div style={{ padding: 16 }}>Select a mission</div>;
    }

    if (!m) {
        return <div style={{ padding: 16 }}>Loading…</div>;
    }

    return (
        <div className="msn-panel-body">
            <MissionDetailContent
                m={m}
                uid={user?.uid}
                completion={null}
                yt={null}
                onShare={() => { }}
                linkCopied={false}
                canEdit={false}
                setEditOpen={() => { }}
                openLightbox={() => { }}
                primaryChecklist={{ doneSet: new Set() }}
                optionalChecklist={{ doneSet: new Set() }}
                doneAll={0}
                totalObjectives={0}
                pct={0}
            />
        </div>
    );
}
